<template>
  <div class="admin-recurring-booking-preview">
    <v-subheader>
      <v-spacer></v-spacer>
      <v-icon class="ml-2"
              color="green">mdi-check-circle-outline
      </v-icon>
      : {{ confirmedCount }}
      <v-icon class="ml-2">mdi-close-circle</v-icon>
      : {{ cancelledCount }}
      <v-icon class="ml-2"
              color="red">mdi-alert-circle
      </v-icon>
      : {{ pendingCount }}
    </v-subheader>

    <v-divider class="my-0"></v-divider>
    <v-list>
      <v-list-group v-for="booking in bookings"
                    no-actions
                    :append-icon="null">
        <template #activator>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ $parseDate(booking.start_time, 'yyyy-MM-dd') }} {{ booking.item.name }} {{ $parseDate(booking.start_time, 'HH:mm') }} - {{ $parseDate(booking.end_time, 'HH:mm') }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>{{ getIcon(booking) }}</v-icon>
          </v-list-item-icon>
        </template>

        <v-radio-group class="mt-0"
                       v-model="results[`${booking.start_time};${booking.end_time}`]">
          <v-subheader v-if="booking.collisions">
            {{ $t('admin_acc_booking_add.recur_replace_booking') }}
          </v-subheader>
          <v-list-item v-if="booking.collisions"
                       v-for="collision in booking.collisions">
            <v-list-item-title>
              {{ $parseDate(booking.start_time, 'yyyy-MM-dd') }} {{ collision.item.name }} {{ $parseDate(booking.start_time, 'HH:mm') }} - {{ $parseDate(booking.end_time, 'HH:mm') }}
              <v-tooltip bottom>
                <template #activator="{on, props}">
                  <v-btn v-bind="props"
                         v-on="on"
                         icon>
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>

                <div v-for="collidedBooking in collision.collisions"
                      :key="collidedBooking.id">
                  {{ collidedBooking.hkiarace_account ? ("[" + collidedBooking.hkiarace_account.serial_no.toString().padStart(6, '0') + "] " + $t('name', {given_name: collidedBooking.hkiarace_account.given_name, surname: collidedBooking.hkiarace_account.surname})) : $t('admin_acc_booking_add.maintenance_booking') }} {{ $parseDate(collidedBooking.start_time, 'yyyy-MM-dd') }} {{ collidedBooking.item.name }} {{ $parseDate(collidedBooking.start_time, 'HH:mm') }} - {{ $parseDate(collidedBooking.end_time, 'HH:mm') }}
                </div>
              </v-tooltip>
            </v-list-item-title>

            <v-list-item-action>
              <v-radio :value="collision.item.id"></v-radio>
            </v-list-item-action>
          </v-list-item>

          <v-subheader v-if="booking.options">
            {{ $t('admin_acc_booking_add.recur_select_other_option') }}
          </v-subheader>
          <v-list-item v-if="booking.options"
                       v-for="option in booking.options">
            <v-list-item-title>
              {{ $parseDate(booking.start_time, 'yyyy-MM-dd') }} {{ option.item.name }} {{ $parseDate(booking.start_time, 'HH:mm') }} - {{ $parseDate(booking.end_time, 'HH:mm') }}
            </v-list-item-title>

            <v-list-item-action>
              <v-radio :value="option.item.id"></v-radio>
            </v-list-item-action>
          </v-list-item>

          <v-list-item v-if="!booking.options">
            <v-list-item-title>
              {{ $parseDate(booking.start_time, 'yyyy-MM-dd') }} {{ booking.item.name }} {{ $parseDate(booking.start_time, 'HH:mm') }} - {{ $parseDate(booking.end_time, 'HH:mm') }}
            </v-list-item-title>

            <v-list-item-action>
              <v-radio :value="booking.item.id"></v-radio>
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="font-weight-bold">
              {{ $t('admin_acc_booking_add.recur_cancel_booking') }}
            </v-list-item-title>

            <v-list-item-action>
              <v-radio :value="false"></v-radio>
            </v-list-item-action>
          </v-list-item>
        </v-radio-group>

      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import _ from 'lodash'
import {computed, onMounted, ref, watch} from '@vue/composition-api'

export default {
  name: 'AdminRecurringBookingPreview',
  components: {},
  props: {
    value: Array,
    refreshTrigger: Boolean,

    itemId: String,
    recurrence: String,
    startDate: String,
    endDate: String,
    startTime: String,
    endTime: String,
  },
  setup(props, {root, emit}) {
    const bookings = ref([]);
    const results = ref({});
    const confirmedCount = computed(() => {
      return _.filter(results.value, (v, k) => typeof v !== 'boolean').length;
    });
    const cancelledCount = computed(() => {
      return _.filter(results.value, (v, k) => v === false).length;
    });
    const pendingCount = computed(() => {
      return bookings.value.length - confirmedCount.value - cancelledCount.value;
    })
    const getIcon = function (booking) {
      let s = `${booking.start_time};${booking.end_time}`;
      let result = results.value[s];

      if (result === undefined) return 'mdi-alert-circle';
      if (typeof result !== 'boolean') return 'mdi-check-circle-outline';
      return 'mdi-close-circle'
    }
    const load = async function () {
      root.$callAPI('aafb/admin/booking/preview_recurring_booking/', {
        item_id: props.itemId,
        recurrence: props.recurrence,
        from_date: props.startDate,
        to_date: props.endDate,
        from_time: props.startTime,
        to_time: props.endTime,
      }, (response) => {
        bookings.value = response.body.results;

        let a = {};
        bookings.value.forEach((b) => {
          if (!b.options) {
            a[`${b.start_time};${b.end_time}`] = b.item.id;
          }
        });

        results.value = a;
      });
    }

    onMounted(() => {
      load();
    });

    watch(() => [props.itemId, props.recurrence, props.startDate, props.endDate, props.startTime, props.endTime], () => {
      load();
    })

    watch(() => results.value, (newValue) => {
      if (pendingCount.value === 0) {
        emit('input', {
          cancelled: cancelledCount.value,
          bookings: newValue,
        });
      } else {
        emit('input', null);
      }
    }, {deep: true})

    return {
      bookings,
      results,
      confirmedCount,
      cancelledCount,
      pendingCount,
      getIcon,
    }
  }
}
</script>

<style lang="less">
.admin-recurring-booking-preview {
  height: 100%;
  display: flex;
  flex-direction: column;

  overflow: hidden;

  .v-subheader, hr {
    flex: 0 0 auto;
  }

  .v-list {
    flex: 1 1 0;

    display: flex;
    flex-direction: column;
    overflow-y: auto;

    text-align: left;

    .v-list-group {
      border: solid 1px rgba(0, 0, 0, 0.2);
    }
  }

  .mdi-alert-circle {
    color: red !important;
  }

  .mdi-check-circle-outline {
    color: green !important;
  }
}
</style>
